var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0225C24.8366 32.0225 32 24.859 32 16.0225C32 7.1859 24.8366 0.0224609 16 0.0224609C7.16344 0.0224609 0 7.1859 0 16.0225C0 24.859 7.16344 32.0225 16 32.0225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 27.3362C-1.56258 21.0878 -1.56258 10.9572 4.68579 4.70874C4.68536 4.70943 13.9126 16.0225 13.9126 16.0225L4.68579 27.3362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9134 16.0223L2.12241 8.05435C1.75685 8.68979 1.43447 9.35304 1.15747 10.0395L7.12678 16.0224L1.15766 22.0055C1.43441 22.6915 1.75647 23.3543 2.12178 23.9893L13.9134 16.0223Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8642 13.9356H13.9123L4.68578 4.70908C3.69153 5.70333 2.82772 6.82776 2.12172 8.0547L10.0742 16.0226L2.12109 23.9895C2.82709 25.2167 3.69128 26.3415 4.68578 27.336L13.9123 18.1095H31.8642C31.9532 17.4264 31.9997 16.7299 31.9997 16.0226C31.9997 15.3153 31.9532 14.6188 31.8642 13.9356V13.9356Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25806 28.7146C8.95612 30.7884 12.3334 32.0222 15.9994 32.0222C23.3919 32.0222 29.6122 27.0084 31.4482 20.1962H14.7765L6.25806 28.7146Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4482 11.8485C29.6122 5.03627 23.3919 0.0224609 15.9994 0.0224609C12.3334 0.0224609 8.95612 1.25627 6.25806 3.33015L14.7764 11.8485H31.4482Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/south-africa.24a43345.svg";
export { ForwardRef as ReactComponent };